import { Component, OnInit, Input } from '@angular/core';
import { HubspotLocationOnboarding } from 'ng2/app/models/hubspot-location-from-onboarding';
import { TypeformLocationOnboarding } from '../../models/typeform-location-from-onboarding';

@Component({
  selector: 'app-onboarding-location-view',
  templateUrl: './onboarding-location-view.component.html',
  styleUrls: ['./onboarding-location-view.component.scss']
})
export class OnboardingLocationViewComponent implements OnInit {
  // @Input() loc: HubspotLocationOnboarding | TypeformLocationOnboarding;
  @Input() loc: any;
  @Input() isTypeform = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/ng2/app/components/onboarding-location-view/onboarding-location-view.component.ts